exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-00cc39ad] .md-table-head-label {\n  color: #4caf50 !important;\n}\n[data-v-00cc39ad] .md-table-head {\n  cursor: default;\n}\n.table-hover[data-v-00cc39ad] {\n  cursor: pointer;\n}\n", ""]);

// exports
